import React from 'react'
import banner from './images/banner.jpeg'


function Home() {
  return (
    <div className="mt-1">
        <img src={banner} alt="" />
    </div>
  )
}

export default Home